import React from 'react';
import BodyContainer from '../ui/BodyContainer';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';

import { useHistory } from 'react-router-dom';
const useStyles = makeStyles((theme) => ({
  gridOccupy: {
    width: '100%',
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#fff',
  },
  inputStyles: {
    height: 25,
    minWidth: 320,
    marginRight: theme.spacing(1),
    marginLeft: theme.spacing(1),
    marginTop: theme.spacing(2.5),
    marginBottom: theme.spacing(2.5),
    flex: 1,
    paddingLeft: 5,
  },

  button: {
    marginTop: '1rem',
    backgroundColor: 'green',
    marginLeft: '0.5rem',
    marginRight: '0.5rem',
    marginBottom: '0.5rem',
  },
}));

function MyAccount() {
  const classes = useStyles();
  const history = useHistory();

  return (
    <BodyContainer title="My Account">
      <Grid className={classes.gridOccupy}>
        <Paper elevation={0} className={classes.root}>
          <div style={{ alignSelf: 'flex-start' }}>
            <nav>
              <ul>
                <li>
                  <Button
                    size="medium"
                    color="primary"
                    style={{ textTransform: 'capitalize' }}
                    onClick={() => history.push('/myprofile')}
                  >
                    My Profile
                  </Button>
                </li>
                {/* <li>
                  <Button
                    size="medium"
                    color="primary"
                    style={{ textTransform: 'capitalize' }}
                    onClick={() => history.push('/changepassword')}
                  >
                    Sign Out
                  </Button>
                </li> */}
                <li>
                  <Button
                    size="medium"
                    color="primary"
                    style={{ textTransform: 'capitalize' }}
                    onClick={() => history.push('/changepassword')}
                  >
                    Change Password
                  </Button>
                </li>
              </ul>
            </nav>
          </div>
        </Paper>
      </Grid>
    </BodyContainer>
  );
}

export default MyAccount;
